function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { Select } from '@nackle/paper';
const {
  Option
} = Select;
import { filterOptions } from '../options/options';
import RosterService from '../../services/roster';
export default class HierarchySelect extends React.Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "state", {
      loading: false,
      hierarchies: []
    });
    _defineProperty(this, "loadHierarchies", async () => {
      const {
        auth
      } = this.props;
      this.setState({
        loading: true
      });
      try {
        const rosterService = new RosterService(auth.state);
        const hierarchies = await rosterService.listHierarchies();
        this.setState({
          hierarchies,
          loading: false
        });
      } catch (error) {
        console.error(error);
        this.setState({
          loading: false
        });
      }
    });
  }
  componentDidMount() {
    this.loadHierarchies();
  }
  render() {
    const {
      ...props
    } = this.props;
    const {
      loading,
      hierarchies
    } = this.state;
    return /*#__PURE__*/React.createElement(Select, _extends({
      loading: loading,
      showSearch: true,
      optionFilterProp: "children",
      filterOption: filterOptions
    }, props), hierarchies.map(hierarchy => /*#__PURE__*/React.createElement(Option, {
      key: hierarchy.id,
      value: hierarchy.id
    }, hierarchy.name)));
  }
}
//# sourceMappingURL=hierarchy-select.js.map